import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Container } from 'components/Layout'

import ConfirmationCodeForm from '../ConfirmationCodeForm'

const ConfirmationCodeFormModalComponent = props => {
  const { type, sendOnShow, recipient, confirmed, creating, modalCancel } = props

  const isFirstRun = useRef(true)

  useEffect(() => {
    // skip first render because confirmed can be still true from previous token
    if (isFirstRun.current) {
      isFirstRun.current = false
      return
    }

    if (confirmed && !creating) {
      modalCancel()
    }
  }, [confirmed])

  return (
    <Container paddingTop paddingBottom className="sm">
      <ConfirmationCodeForm
        type={type} // type of confirmation 'email' or 'tel'
        sendOnShow={sendOnShow} // do we need to send create request when form is shown
        recipient={recipient} // email or number (either entered value or confirmation.value)
      />
    </Container>
  )
}

const stateToProps = ({ auth: { user }, auth }, { type }) => ({
  confirmed:
    type === 'email' ? user.emailConfirmation?.isConfirmed : user.phoneConfirmation?.isConfirmed,
  creating: type === 'email' ? auth.emailConfirmationLoading : auth.phoneConfirmationLoading,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(ConfirmationCodeFormModalComponent)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeFormModal/ConfirmationCodeFormModal.jsx